module.exports = __webpack_public_path__ + "5c4c33db1c8cce66c0831327632f65a3.png";